module.exports = __webpack_public_path__ + "img/2.1b9653a7.png";